//bao migrate skip
import "./../../bindings/bao-upload";
import Bao from "./../../services/bao-service";
import * as ko from "knockout";
import * as $ from "jquery";
import baoDialog from "../../factories/bao-dialog";

class ReminderReferenceDocument {
    constructor(data: any, dialog: baoDialog) {
        this.Dialog = dialog;
        $.extend(this, data);
        data.Parent.ItemCompleteCheck = this.ItemCompleteCheck; //TODO: schöner Machen! Anpassung in dialog notwendig. Vermutlich über neuen Dialog (baoDialog2)
        this.UploadDocumentBinding = {
            Url: 'ReminderReferenceDocument/Upload?configurationItemReminderReferenceDocumentId=' + this.ConfigurationItemReminderReferenceDocumentId(),
            Upload: 'Upload',
            Enabled: this.IsDocumentNew
        };
    }
    Dialog: baoDialog;
    MetaData = ko.observable<string>();
    Class = ko.observable<string>();
    DocumentName = ko.observable<string>();
    ConfigurationItemReminderReferenceDocumentId = ko.observable<string>();
    IsDocumentNew = ko.observable(true);
    UploadDocumentBinding: Bindings.baoUpload;
    ItemCompleteCheck = (item: any): JQueryPromise<boolean> => {
        let def = $.Deferred<boolean>();
        if (!Bao.Utils.String.IsNullOrWhitespace(this.Class()) && !Bao.Utils.String.IsNullOrWhitespace(this.DocumentName())) {
            if (this.IsDocumentNew()) {
                this.Dialog.IsLoading(true);
                this.Upload().then(() => {
                    this.Dialog.IsLoading(false);
                    def.resolve(true);
                });
            }
            else {
                def.resolve(true);
            }
        }
        else {
            def.resolve(false);
        }
        return def.promise();
    };
    Upload(): JQueryPromise<any> {
        //Dummy
        return null;
    }
    init() {
    }
    loaded() {
    }
}
export default ReminderReferenceDocument;